import type { Doc } from "@soonlist/backend/convex/_generated/dataModel";
import type { User } from "@soonlist/validators";

export function transformConvexUser(
  user: Doc<"users"> & { isSupporter?: boolean },
): User {
  return {
    ...user,
    createdAt: new Date(user.created_at),
    updatedAt: user.updatedAt ? new Date(user.updatedAt) : null,
    onboardingCompletedAt: user.onboardingCompletedAt
      ? new Date(user.onboardingCompletedAt)
      : null,
  };
}
